import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AutoTablePageableResponse } from '@muchencute/mrrs-types';
import { CustomerMessage, CustomerMessageStatus, CustomerMessageReplyLog } from './customer-message-models';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { CORE_CONFIG } from '../environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerMessageService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
              @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = `${this.coreConfig.endpoint}api/v1/customermessage`;
  }

  getCustomerMessageList(params: { [param: string]: any }): Observable<AutoTablePageableResponse<CustomerMessage>> {
    return this.httpClient.get<AutoTablePageableResponse<CustomerMessage>>(`${this._baseURL}s`, {
      params
    });
  }

  getCustomerMessageReplies(messageID: string): Observable<CustomerMessageReplyLog> {
    return this.httpClient.get<CustomerMessageReplyLog>(`${this._baseURL}/${messageID}/replies`);
  }

  removeCustomerMessage(id: string | string[]): Observable<any> {
    if (!_.isArray(id)) {
      return this.httpClient.delete(`${this._baseURL}/${id}`);
    } else {
      return this.httpClient.delete(this._baseURL, {
        params: {
          id
        }
      });
    }
  }

  updateCustomerMessageStatus(id: string | string[], status: CustomerMessageStatus): Observable<any> {
    if (!_.isArray(id)) {
      return this.httpClient.patch(`${this._baseURL}/${id}`, {}, {
        params: {
          status
        }
      });
    } else {
      return this.httpClient.patch(this._baseURL, {}, {
        params: {
          id,
          status
        }
      });
    }
  }

  replyCustomerMessage(messageReplyLog: CustomerMessageReplyLog): Observable<CustomerMessageReplyLog> {
    return this.httpClient.post<CustomerMessageReplyLog>(`${this._baseURL}/${messageReplyLog.messageID}`, messageReplyLog);
  }

  newCustomerMessage(message: CustomerMessage): Observable<CustomerMessage> {
    return this.httpClient.post<CustomerMessage>(`${this._baseURL}`, message);
  }
}
